// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressOptionalRequest } from './address-optional-request';

// @ts-ignore
import { OrderProductOptionRequest } from './order-product-option-request';

// @ts-ignore
import { UpdateEyeglassLensMeasurementsRequest } from './update-eyeglass-lens-measurements-request';

// @ts-ignore
import { UpdateEyeglassLensOrderDetailRequest } from './update-eyeglass-lens-order-detail-request';

// @ts-ignore
import { UpdateOrderRequest } from './update-order-request';

/** See com.rev360.pms.api.controller.order.UpdateEyeglassOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateEyeglassOrderRequest extends UpdateOrderRequest {

	@GandalfSubRequestLabel('AR Coating')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	arCoating!: OrderProductOptionRequest | null;

	@GandalfValidator({ sizeString: { message: 'AR Coating Side cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	arCoatingSide!: string | null;

	@GandalfValidator({ sizeString: { message: 'Comment cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfValidator({ min: { min: 0, message: 'Density % must be between 0 and 100' } })
	@GandalfValidator({ max: { max: 100, message: 'Density % must be between 0 and 100' } })
	@GandalfProperty({ designType: Number })
	density!: number | null;

	@GandalfProperty({ designType: Number })
	distancePd!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dueDate!: Date | null;

	@GandalfSubRequestLabel('Edge Treatment')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	edgeTreatment!: OrderProductOptionRequest | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfLabel('Estimate Discounts')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedDiscounts!: number | null;

	@GandalfLabel('Estimated Insurance Benefit')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedInsuranceBenefit!: number | null;

	@GandalfValidator({ sizeString: { message: 'Frame Supplier cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	externalFrameSupplierIdentifier!: string | null;

	@GandalfValidator({ sizeString: { message: 'Frame Supplier Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	externalFrameSupplierName!: string | null;

	@GandalfValidator({ sizeString: { message: 'Supplier cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	externalSupplierIdentifier!: string | null;

	@GandalfValidator({ sizeString: { message: 'Supplier Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	externalSupplierName!: string | null;

	@GandalfProperty({ designType: Number })
	frameColorId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameCost!: number | null;

	@GandalfProperty({ designType: Number })
	frameId!: number | null;

	@GandalfProperty({ designType: Number })
	frameItemId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameRemakeCost!: number | null;

	@GandalfProperty({ designType: Number })
	frameSizeId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Instructions cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	lensCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	lensRemakeCost!: number | null;

	@GandalfConstantDecorator(constants.OrderLensRequest)
	@GandalfValidator({ notNull: { message: 'Lens Request is required' } })
	@GandalfProperty({ designType: constants.OrderLensRequest, isRequired: true })
	lensRequest!: constants.OrderLensRequest;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfSubRequestLabel('Material')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	material!: OrderProductOptionRequest | null;

	@GandalfSubRequestLabel('Mirror Coating')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	mirrorCoating!: OrderProductOptionRequest | null;

	@GandalfSubRequestLabel('Mounting Type')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	mountingType!: OrderProductOptionRequest | null;

	@GandalfProperty({ designType: Number })
	nearPd!: number | null;

	@GandalfValidator({ sizeString: { message: 'Notification Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	notificationComments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	notificationDate!: Date | null;

	@GandalfSubRequestLabel('OD')
	@GandalfValidator({ notNull: { message: 'OD details are required' } })
	@GandalfProperty({ designType: UpdateEyeglassLensOrderDetailRequest, isRequired: true })
	odLensDetail!: UpdateEyeglassLensOrderDetailRequest;

	@GandalfSubRequestLabel('OD')
	@GandalfValidator({ notNull: { message: 'OD measurements are required' } })
	@GandalfProperty({ designType: UpdateEyeglassLensMeasurementsRequest, isRequired: true })
	odLensMeasurements!: UpdateEyeglassLensMeasurementsRequest;

	@GandalfConstantDecorator(constants.OrderOpticalCenterType)
	@GandalfProperty({ designType: constants.OrderOpticalCenterType })
	opticalCenterType!: constants.OrderOpticalCenterType | null;

	@GandalfConstantDecorator(constants.OrderFrameIndication)
	@GandalfValidator({ notNull: { message: 'Frame Indicator is required' } })
	@GandalfProperty({ designType: constants.OrderFrameIndication, isRequired: true })
	orderFrameIndication!: constants.OrderFrameIndication;

	@GandalfConstantDecorator(constants.OrderFrameSource)
	@GandalfValidator({ notNull: { message: 'Frame Source is required' } })
	@GandalfProperty({ designType: constants.OrderFrameSource, isRequired: true })
	orderFrameSource!: constants.OrderFrameSource;

	@GandalfValidator({ notNull: { message: 'Order is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	orderId!: number;

	@GandalfSubRequestLabel('OS')
	@GandalfValidator({ notNull: { message: 'OS details are required' } })
	@GandalfProperty({ designType: UpdateEyeglassLensOrderDetailRequest, isRequired: true })
	osLensDetail!: UpdateEyeglassLensOrderDetailRequest;

	@GandalfSubRequestLabel('OS')
	@GandalfValidator({ notNull: { message: 'OS measurements are required' } })
	@GandalfProperty({ designType: UpdateEyeglassLensMeasurementsRequest, isRequired: true })
	osLensMeasurements!: UpdateEyeglassLensMeasurementsRequest;

	@GandalfSubRequestLabel('Other Coating')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	otherCoating!: OrderProductOptionRequest | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	otherCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	otherRemakeCost!: number | null;

	@GandalfProperty({ designType: Number })
	pantoscopicTilt!: number | null;

	@GandalfValidator({ notNull: { message: 'Patient Notified is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	patientNotified!: boolean;

	@GandalfSubRequestLabel('Photochromic')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	photochromic!: OrderProductOptionRequest | null;

	@GandalfSubRequestLabel('Polarized')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	polarized!: OrderProductOptionRequest | null;

	@GandalfProperty({ designType: Number })
	prescriptionId!: number | null;

	@GandalfProperty({ designType: Number })
	processorId!: number | null;

	@GandalfValidator({ notNull: { message: 'Quantity is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	quantity!: number;

	@GandalfSubRequestLabel('Scratch Coating')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	scratchCoating!: OrderProductOptionRequest | null;

	@GandalfConstantDecorator(constants.OrderSegHeightType)
	@GandalfProperty({ designType: constants.OrderSegHeightType })
	segHeightType!: constants.OrderSegHeightType | null;

	@GandalfValidator({ sizeString: { message: 'Shade cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	shade!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shipCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shipRemakeCost!: number | null;

	@GandalfProperty({ designType: AddressOptionalRequest })
	shipToOtherAddress!: AddressOptionalRequest | null;

	@GandalfConstantDecorator(constants.OrderShipToType)
	@GandalfValidator({ notNull: { message: 'Ship To is required' } })
	@GandalfProperty({ designType: constants.OrderShipToType, isRequired: true })
	shipToType!: constants.OrderShipToType;

	@GandalfConstantDecorator(constants.OrderShipmentCompany)
	@GandalfProperty({ designType: constants.OrderShipmentCompany })
	shippingCompany!: constants.OrderShipmentCompany | null;

	@GandalfConstantDecorator(constants.OrderShippingSpeed)
	@GandalfProperty({ designType: constants.OrderShippingSpeed })
	shippingSpeed!: constants.OrderShippingSpeed | null;

	@GandalfSubRequestLabel('Special Option')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	specialOption!: OrderProductOptionRequest | null;

	@GandalfSubRequestLabel('Thickness')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	thickness!: OrderProductOptionRequest | null;

	@GandalfSubRequestLabel('Tint Factor')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	tintFactor!: OrderProductOptionRequest | null;

	@GandalfSubRequestLabel('Tint Type')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	tintType!: OrderProductOptionRequest | null;

	@GandalfValidator({ sizeString: { message: 'Tracking # cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	trackingNumber!: string | null;

	@GandalfValidator({ sizeString: { message: 'Tray cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	tray!: string | null;

	@GandalfSubRequestLabel('UV Treatment')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	uvTreatment!: OrderProductOptionRequest | null;

	@GandalfProperty({ designType: Number })
	vendorId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Vendor Order # cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	vendorOrderIdentifier!: string | null;

	@GandalfValidator({ notNull: { message: 'Version is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	version!: number;

	@GandalfProperty({ designType: Number })
	wrapAngle!: number | null;

}
